import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import images from "../../../../../../../../utilities/images/images";
import "./CouponCoin.scss";
import HandbookAddress from "../../handbookaddress/HandbookAddress";
import useGetCartProducts from "../../hooks/cart_products/useGetCartProducts";
import PaytmHandbook from "../../payment/PaytmHandbook";
import HandbookCouponList from "../modals/handbookcoupon/HandbookCouponList";
import axios from "axios";
import { toastifyMessage } from "../../../../../../../../custom_utilities/toastify_config";
import { initiateHandbookPaytmOrder } from "../../../../../../../../custom_utilities/paytm_payment/paytmHandbookHelpers";
import {
  setOrderId,
  setPaytmDataInStore,
} from "../../../../../../../../redux/payment_gateway/action";
import "react-toastify/dist/ReactToastify.css";
import {
  trackWebEngageCouponApplied,
  trackWebEngageCouponFailed,
  trackWebEngageViewCoupons,
} from "../../../../../../../../custom_utilities/webengage/webengageService";

const CouponCoin = ({
  token,
  tokenType,
  user_id,
  paymentAction,
  setPaytmDataInStore,
}) => {
  const location = useLocation();

  // ✅ Now accurat ly reflects if navigation was from cart icon
  const fromCart = location.state?.fromCart === true;

  const {
    cartProducts,
    productId,
    productsPrice,
    productsDiscountPrice,
    finalPrice,
    eligibleMotionCoins,
    shippingCharge,
  } = useGetCartProducts({ token, tokenType });

  const [finalAmount, setFinalAmount] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [showCouponList, setShowCouponList] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [isCouponApplied, setIsCouponApplied] = useState(false);

  useEffect(() => {
    if (finalPrice != null && !isNaN(finalPrice)) {
      setFinalAmount(finalPrice);
    }
  }, [finalPrice]);

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    if (checked) {
      setFinalAmount(finalAmount - eligibleMotionCoins);
    } else {
      setFinalAmount(finalPrice);
    }
  };

  const applyCoupon = async () => {
    if (couponCode.length === 0) {
      alert("Please Enter the Coupon Code");
      trackWebEngageCouponFailed({ coupon_code: couponCode, source: "handbook" });
      return;
    }

    if (isCouponApplied) {
      setFinalAmount(finalPrice);
      setCouponDiscount(0);
      setIsCouponApplied(false);
      setCouponCode("");
      handleCloseCoupon();
      return;
    }

    try {
      const { orderId: resolvedOrderId, responseData } =
        await initiateHandbookPaytmOrder({
          user_id,
          product_id: cartProducts?.[0]?.p_id,
          price: productsPrice,
          discount: productsDiscountPrice,
          coupon_discount: 0,
          shipping_charge: shippingCharge,
          total_price: finalPrice,
          from_cart: "true",
          coins_count: isChecked ? eligibleMotionCoins : "0",
          is_referal: 0,
        });

      paymentAction(resolvedOrderId);
      setPaytmDataInStore(responseData);

      const payloadData = {
        amount: finalPrice,
        coupon_code: couponCode,
        product_id: cartProducts?.[0]?.p_id,
        order_id: resolvedOrderId,
        is_coupon: true,
      };

      const response = await axios.post(
        "https://learning.motion.ac.in/motioneducation/api/v1/handbook_coupon",
        payloadData
      );

      if (response.data.status === 200) {
        toastifyMessage({
          status: response.data.data.status,
          message: response.data.data.message,
        });

        const updatedAmount = Number(response.data.data.updated_amount);
        const previousAmount = Number(finalPrice);
        const discountAmount = Math.max(0, previousAmount - updatedAmount);

        setFinalAmount(updatedAmount);
        setCouponDiscount(discountAmount);
        setIsCouponApplied(true);
        trackWebEngageCouponApplied({
          coupon_code: couponCode,
          order_coupon_code: couponCode,
          discount_amount: discountAmount,
          cart_value_before_discount: previousAmount,
          cart_value_after_discount: updatedAmount,
          source: "handbook",
          coupon_type: "handbook",
        });
        handleCloseCoupon();
      } else {
        trackWebEngageCouponFailed({ coupon_code: couponCode, source: "handbook" });
        toastifyMessage({
          status: response.data.status,
          message: response.data.message,
        });
      }
    } catch (error) {
      console.error("Error applying coupon", error);
      trackWebEngageCouponFailed({ coupon_code: couponCode, source: "handbook" });
      handleCloseCoupon();
    }
  };

  const formatTwoDigits = (value) => {
    return value != null ? String(value).padStart(1, "0") : "00";
  };

  const openCouponList = () => {
    trackWebEngageViewCoupons();
    setShowCouponList(true);
  };
  const handleCloseCoupon = () => setShowCouponList(false);

  const checkApplyCouponBtnDisabled = () => {
    if (couponCode.length === 0) {
      return "disableapplybtn";
    }
    return "";
  };

  const handleOnChangeCouponCode = (e) => {
    setCouponCode(e.target.value);
  };

  return (
    <div className="handbook_coupon_coin_wrapper">
      <HandbookAddress />

      <div className="header--">
        <div className="title--">
          <img src={images.coupon} alt="Coupon icon" />
          <span>Apply Coupon</span>
          <button className="view-coupons" onClick={openCouponList}>
            View Coupons
          </button>
        </div>
      </div>

      <div className="coupon-input">
        <input
          type="text"
          placeholder=" Enter Coupon Code"
          value={couponCode}
          onChange={handleOnChangeCouponCode}
        />
        <button onClick={applyCoupon} className={checkApplyCouponBtnDisabled()}>
          {isCouponApplied ? "Remove" : "Apply"}
        </button>
      </div>

      <div className="price-details">
        <h3>Price details</h3>

        <div className="price-row">
          <span>Total products({cartProducts?.length})</span>
          <span>-₹{productsPrice?.toFixed(2)}</span>
        </div>

        <div className="price-row">
          <span>Discount</span>
          <span className="price-value">₹{productsDiscountPrice?.toFixed(2)}</span>
        </div>

        <div className="price-row">
          <span>Coupon Discount</span>
          <span className="price-value">- ₹{couponDiscount?.toFixed(2)}</span>
        </div>

        <div className="price-row">
          <span>Motion Coins</span>
          <span className="price-value">
            -₹{isChecked ? formatTwoDigits(eligibleMotionCoins) : "0"}
          </span>
        </div>

        <div className="price-row">
          <span>Delivery Charge</span>
          <span>+₹{shippingCharge}</span>
        </div>

        <div className="price-row total">
          <span>Total Price</span>
          <span>₹{finalAmount}</span>
        </div>
      </div>

      {productsPrice && finalAmount && (
        <PaytmHandbook
          buttonText={"Proceed to Pay"}
          handleBookDetails={{
            price: productsPrice,
            discount: productsDiscountPrice,
            coupon_discount: couponDiscount || 0,
            shipping_charge: shippingCharge,
            total_price: finalAmount,
            discounted_price: finalAmount,
            coins_count: isChecked ? eligibleMotionCoins : 0,
            user_id,
            product_id: cartProducts?.[0]?.p_id,
            product_name:
              cartProducts
                ?.map((item) => item?.product_name || item?.name || item?.title)
                .filter(Boolean)
                .join(", ") || "Motion Handbook",
            name: cartProducts?.[0]?.product_name || cartProducts?.[0]?.name,
            title: cartProducts?.[0]?.title,
            description:
              cartProducts?.[0]?.description ||
              cartProducts?.[0]?.short_description ||
              cartProducts?.[0]?.PackageInstallmentDetails?.description ||
              cartProducts?.[0]?.type ||
              "Handbook purchase",
            type: cartProducts?.[0]?.type,
            coupon_code: couponCode || undefined,
            // from_cart: fromCart, 
            from_cart: true,
          }}
          finalAmount={finalAmount}
        />
      )}

      {showCouponList && (
        <HandbookCouponList
          couponCode={couponCode}
          setCouponCode={setCouponCode}
          applyCoupon={applyCoupon}
          handleCloseCoupon={handleCloseCoupon}
          checkApplyCouponBtnDisabled={checkApplyCouponBtnDisabled}
          handleOnChangeCouponCode={handleOnChangeCouponCode}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loader: state.ui.loader,
  token: state.auth.authToken,
  tokenType: state.auth.tokenType,
  user_id: state.auth.user.user_id,
});

const mapDispatchToProps = (dispatch) => ({
  paymentAction: (payload) => dispatch(setOrderId(payload)),
  setPaytmDataInStore: (payload) => dispatch(setPaytmDataInStore(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CouponCoin);
